<template>
    <v-snackbar :value="value" :timeout="-1" centered color="accent darken-2">
        <div v-if="Object.keys(print).length === 0">
            <h4 class="mb-2">Printing Order ...</h4>
            <v-progress-linear
                indeterminate
                color="accent"
                height="10"
            ></v-progress-linear>
        </div>
        <div v-else>
            <v-btn
                block
                :href="print.signedUrl"
                target="_blank"
                color="accent"
                @click="$emit('input', false)"
            >
                <v-icon class="mr-2">mdi-adobe</v-icon>View Report
            </v-btn>
        </div>
        <template v-slot:action="{ attrs }">
            <v-btn
                color="success"
                text
                v-bind="attrs"
                @click="$emit('input', false)"
            >
                Close
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        order_id: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            print: {},
            uuid: this.$uuid.v4(), // unique id for this print request
        };
    },
    watch: {
        prints(prints) {
            this.print = prints.find((print) => print.uuid === this.uuid);
            if (!this.print.success) {
                this.$emit("input", false); // closes the snackbar, error will be handled in dispatched store message
            }
        },
    },
    computed: {
        ...mapGetters("Screens", ["prints"]),
    },
    methods: {
        ...mapActions("Screens", ["printScreen"]),
    },
    mounted() {
        this.printScreen({
            id: this.order_id,
            uuid: this.uuid,
        });
    },
};
</script>

<style lang="scss" scoped>
</style>